ms
<template>
  <div class="role-user">
    <!-- 条件搜索部分 -->
    <el-form class="zwx-form" key="mainForm" ref="mainForm" :model="mainForm" label-position="right"
             @submit.native.prevent>
      <div style="max-width: 500px;">
        <el-form-item label-width="70px" label="地区：">
          <zwx-select-area ref="areaIdArea" @loadOver="areaIdLoadOver()" :zoneCode12From="zoneCode12From"
                           zoneTypeMax="0" zoneTypeMin="4" :showFullName="false" :disabled="false" :clearable="false"/>
        </el-form-item>
        <el-form-item label-width="70px" label="机构名称：">
          <el-input class="zwx-input" v-model="mainForm.unitNameLike" placeholder="请输入" @keyup.enter.native="search(1)"
                    clearable/>
        </el-form-item>
        <el-form-item label-width="70px" label="用户姓名：">
          <el-input class="zwx-input" v-model="mainForm.userNameLike" placeholder="请输入" @keyup.enter.native="search(1)"
                    clearable/>
        </el-form-item>
        <el-form-item label-width="70px" label="用户账号：">
          <el-input class="zwx-input" v-model="mainForm.userNoLike" placeholder="请输入" @keyup.enter.native="search(1)"
                    clearable/>
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider"/>
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search(1)">查询
      </el-button>
    </div>
    <!-- 列表展示部分 -->
    <el-table class="zwx-table" style="width: 100%;" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="fkByUnitId.fkByZoneId.fullName" label="地区"
                       :width="$system.calWidth(dataList, 'fkByUnitId.fkByZoneId.fullName', '地区')" header-align="left"
                       align="left"/>
      <el-table-column prop="fkByUnitId.unitName" label="机构名称"
                       :width="$system.calWidth(dataList, 'fkByUnitId.unitName', '机构名称')" header-align="left"
                       align="left"/>
      <el-table-column prop="userName" label="用户姓名" :width="$system.calWidth(dataList, 'userName', '用户姓名')"
                       header-align="left" align="left"/>
      <el-table-column prop="userNo" label="用户账号" :width="$system.calWidth(dataList, 'userNo', '用户账号')"
                       header-align="left" align="left"/>
      <el-table-column fixed="right" label="操作" :min-width="74" header-align="left" align="left">
        <template slot-scope="scope">
          <el-checkbox class="zwx-checkbox" v-if="users.ifSuperAdmin || users.uid !== scope.row.uid"
                       v-model="scope.row.ifAuth"
                       @click.native.prevent="$system.msgbox(scope.row, '提示', scope.row.ifAuth ? '确定要取消授权吗？' : '确定要授权吗？', '确定', '取消', userRoleDistribution)">
            授权
          </el-checkbox>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器部分 -->
    <base-pagination :parentPage="currentPage" :pageSize="pageSize" :total="total" @currentChange="currentChange"/>
  </div>
</template>

<script>
export default {
  name: 'RoleUser',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      roleName: this.$route.params.roleName,
      zoneCode12From: undefined,
      mainForm: {
        unitNameLike: '',
        userNameLike: '',
        userNoLike: '',
      },
      dataList: [],
      currentPage: 1,
      pageSize: 18,
      total: 0,
    }
  },
  created() {
    this.$emit('breadcrumb', this.roleName, false)
    this.zoneCode12From = this.users.ifSuperAdmin ? '000000000000' : this.users.fkByUnitId.fkByZoneId.zoneCode12
  },
  mounted() {
    this.$emit('loading', true)
    this.$refs.areaIdArea.initSearch()
  },
  computed: {},
  methods: {
    currentChange(currentPage) {
      this.search(currentPage)
    },
    areaIdLoadOver() {
      this.search(this.currentPage)
    },
    search(currentPage) {
      this.$emit('loading', true)
      this.currentPage = currentPage
      let data = {
        rid: this.rid,
        currentPage: this.currentPage,
        areaId: this.$refs.areaIdArea.getChooseArea().rid,
        unitNameLike: this.mainForm.unitNameLike,
        userNameLike: this.mainForm.userNameLike,
        userNoLike: this.mainForm.userNoLike,
      }
      this.$system.get(this.api + '/systematic/getRoleUserInfoList-1', data, true, true, this.searchSuccess, this.error)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.dataList = data.userInfoList
        this.total = data.userInfoCount
        this.pageSize = data.pageSize
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
      }
      this.$emit('loading', false)
    },
    userRoleDistribution(row) {
      this.$emit('loading', true)
      let data = {
        userUid: row.uid,
        roleId: this.rid,
        ifCheck: !row.ifAuth,
      }
      this.$system.post(this.api + '/systematic/userRoleDistribution-1', data, true, true, this.userRoleDistributionSuccess, this.error)
    },
    userRoleDistributionSuccess(data) {
      if (data.type === '00') {
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
